function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0578 40.9126C30.2543 40.9126 32.8456 38.3018 32.8456 35.0812C32.8456 31.8606 30.2543 29.2498 27.0578 29.2498C23.8612 29.2498 21.2699 31.8606 21.2699 35.0812C21.2699 38.3018 23.8612 40.9126 27.0578 40.9126Z",
  fill: "#FF073A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.0577 37.7318C28.5107 37.7318 29.6886 36.5451 29.6886 35.0812C29.6886 33.6172 28.5107 32.4305 27.0577 32.4305C25.6048 32.4305 24.4269 33.6172 24.4269 35.0812C24.4269 36.5451 25.6048 37.7318 27.0577 37.7318Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1.84331 49.2443L0.0771409 49.7857L0.00250244 18.0559L1.85568 18.6737L1.84331 49.2443Z",
  fill: "#9443FF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.1313 0.000976562L27.1499 2.00312L1.85565 18.6747L0 18.056L27.1313 0.000976562Z",
  fill: "#9443FF"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9314 29.5615L19.8201 30.8951L0.445801 19.0746L1.42765 17.5939L20.9314 29.5615Z",
  fill: "#9443FF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M53.8028 49.5485L52.0312 48.858L52.0576 18.7518L53.9995 17.9387L53.8028 49.5485Z",
  fill: "#FD9D52"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M52.037 46.6572L52.0341 48.8579L33.7147 39.4733L34.6966 37.9926L52.037 46.6572Z",
  fill: "#FD9D52"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M52.0395 48.858L53.8011 49.5468L35.8096 69.4204L34.0718 68.9164L52.0395 48.858Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6653 68.2203L17.72 70L35.8043 69.4356L35.7496 67.6558L17.6653 68.2203Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1.84326 49.2435L0.0770874 49.7861L17.7392 69.9991L19.3833 68.6792L1.84326 49.2435Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M27.1317 0L27.1461 1.99218L52.0588 18.7514L53.9999 17.9371L27.1317 0Z",
  fill: "black"
});

function SvgMakersleagueLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 70,
    viewBox: "0 0 54 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakersleagueLogo);
export default __webpack_public_path__ + "static/media/makersleague-logo.3e9c731d.svg";
export { ForwardRef as ReactComponent };